import { useMemo } from 'react'

import { copyTextToClipboard } from 'helpers'

import { Text, Icon } from 'components/common'

const Share = ({ slug, sharePopup, setSharePopup, setReportPopup }) => {

    const url = useMemo(() => `${process.env.NEXT_PUBLIC_APP_URL}/debate/${slug}`, [slug])

    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`
    const twitterUrl = `https://twitter.com/intent/tweet?url=${url}`
    const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`

    return (
        <div className='share block flexBox alignMiddle'>
            <Icon
                className='darkGrey cursorPointer op-share icon-pop'
                onClick={() => { setSharePopup(!sharePopup); setReportPopup(false) }}
            />
            <div className={`share-popup pop flexBoxColumn ${sharePopup ? 'active' : ''}`}>
                <a target='_blank' href={facebookUrl} className='sharer PopReg h5' rel='noopener noreferrer'>
                    Facebook
                </a>
                <a target='_blank' href={twitterUrl} className='sharer PopReg h5' rel='noopener noreferrer'>
                    Twitter
                </a>
                <a target='_blank' href={linkedinUrl} className='sharer PopReg h5' rel='noopener noreferrer'>
                    Linkedin
                </a>
                <Text onClick={() => copyTextToClipboard(url)} tag='h5' className='sharer PopReg h5 cursorPointer' text='Copy Link' />
            </div>
        </div>
    )
}

export default Share